import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import AutomationsPageRouteView from './AutomationsPageRouteView.vue';
import SettingsContent from '../settings/Wrapper.vue';

// Pages are loaded lazily: the settings pages import shared components that
// import the router, so a static import here would create an import cycle.
const RemindersPage = () => import('./pages/RemindersPage.vue');
const AutomationRules = () => import('../settings/automation/Index.vue');
const Macros = () => import('../settings/macros/Index.vue');
const MacroEditor = () => import('../settings/macros/MacroEditor.vue');
const CannedResponses = () => import('../settings/canned/Index.vue');

const adminPermissions = ['administrator'];
const agentPermissions = [...ROLES, ...CONVERSATION_PERMISSIONS];

const macrosMeta = {
  featureFlag: FEATURE_FLAGS.MACROS,
  permissions: agentPermissions,
};

const followUpMeta = {
  featureFlag: FEATURE_FLAGS.CONVERSATION_FOLLOW_UPS,
  permissions: ['administrator', 'campaign_manage'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/automations'),
      component: AutomationsPageRouteView,
      children: [
        {
          // AutomationsPageRouteView sends the user to the first tab they can
          // access once permissions and account features are loaded.
          path: '',
          name: 'automations_home',
          meta: { permissions: agentPermissions },
          component: { render: () => null },
        },
        {
          path: 'triggers/follow_ups',
          name: 'automations_follow_ups',
          meta: followUpMeta,
          component: () => import('./pages/FollowUpsPage.vue'),
        },
        {
          path: 'triggers/reminders',
          name: 'automations_reminders',
          meta: { permissions: adminPermissions },
          component: RemindersPage,
        },
        {
          path: 'internal/rules',
          name: 'automations_rules',
          meta: {
            featureFlag: FEATURE_FLAGS.AUTOMATIONS,
            permissions: adminPermissions,
          },
          component: AutomationRules,
        },
        {
          path: 'internal/macros',
          name: 'automations_macros',
          meta: macrosMeta,
          component: Macros,
        },
        {
          path: 'internal/canned',
          name: 'automations_canned',
          meta: {
            featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
            permissions: agentPermissions,
          },
          component: CannedResponses,
        },
      ],
    },
    // Follow-up flow pages live outside the tab shell (full-width screens),
    // like the multi-step campaign editor does for campaigns.
    {
      path: frontendURL(
        'accounts/:accountId/automations/triggers/follow_ups/new'
      ),
      name: 'follow_up_flow_new',
      meta: followUpMeta,
      component: () => import('../whatsapp_flows/FollowUpFlowNew.vue'),
    },
    {
      path: frontendURL(
        'accounts/:accountId/automations/triggers/follow_ups/:flowId/edit'
      ),
      name: 'follow_up_flow_edit',
      meta: followUpMeta,
      component: () => import('../whatsapp_flows/FollowUpFlowEdit.vue'),
    },
    {
      path: frontendURL(
        'accounts/:accountId/automations/triggers/follow_ups/:flowId/analytics'
      ),
      name: 'follow_up_flow_analytics',
      meta: followUpMeta,
      component: () => import('../whatsapp_flows/FollowUpFlowAnalytics.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/automations/internal/macros'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'MACROS.HEADER',
          icon: 'flash-settings',
          showBackButton: true,
          backUrl: { name: 'automations_macros' },
        };
      },
      children: [
        {
          path: ':macroId/edit',
          name: 'macros_edit',
          component: MacroEditor,
          meta: macrosMeta,
        },
        {
          path: 'new',
          name: 'macros_new',
          component: MacroEditor,
          meta: macrosMeta,
        },
      ],
    },
  ],
};
